import { Stack, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";
import { ConditionValidation, DimensionValidation } from "./DimensionValidation";
import type { ConditionValidationResult, DimensionValidationResult } from "../../../../../../../api/types/svTypes.ts";

interface FieldsValidationProps {
  caption: string;
  fields?: DimensionValidationResult[] | null;
}
export function FieldsValidation({ caption, fields }: FieldsValidationProps) {
  if (!fields) return null;
  return (
    <FieldsContainer caption={caption}>
      {fields.map((f, index) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <DimensionValidation key={f.name + index} field={f} sx={{ py: 0.5 }} />
      ))}
    </FieldsContainer>
  );
}
export function ConditionsValidation({ conditions }: { conditions?: ConditionValidationResult[] | null }) {
  if (!conditions) return null;
  return (
    <FieldsContainer caption="Conditions">
      {conditions.map((c, index) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <ConditionValidation key={c.name + index} field={c} sx={{ py: 0.5 }} />
      ))}
    </FieldsContainer>
  );
}
export function FieldsContainer({ caption, children }: PropsWithChildren<{ caption: string }>) {
  return (
    <Stack spacing={1} useFlexGap sx={{ width: "100%" }}>
      <Typography variant="subtitle2">{caption}</Typography>
      {children}
    </Stack>
  );
}
